import script from "./TableCommonVue3.vue?vue&type=script&setup=true&lang=js"
export * from "./TableCommonVue3.vue?vue&type=script&setup=true&lang=js"

import "./TableCommonVue3.vue?vue&type=style&index=0&id=2cf97a74&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cf97a74"]])

export default __exports__